import { TOAST_TYPES } from "enum/enums";
import { handleErrorMessage } from "lib/utils";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { addToast } from "store/toaster/reducer";
import { setError, setEvents, setLoading, setRegisterLoading, setWebhook, setWebhooks } from "./reducer";
import webhookService from "services/webhookService";
import { HANDLE_DELETE_WEBHOOK, HANDLE_GET_WEBHOOK_EVENTS, HANDLE_GET_WEBHOOK_LIST, HANDLE_PATCH_WEBHOOK, HANDLE_REGISTER_WEBHOOK } from "./action.types";
import { RootState } from "store/store";

function* fetchWebhooksData(): Generator {
	yield put(setLoading(true));
	yield put(setError(false));
	yield put(setWebhook(null))
	const state: any = yield select((state: RootState) => state.auth);
	try {
		yield put({ type: HANDLE_GET_WEBHOOK_EVENTS });
		const res: any = yield call(webhookService.getWebhookList, state.selectedTenant?.tenantId);
		yield put(setWebhooks(res?.data?.webhooks));
	} catch (error) {
		yield put(setError(true));
		yield put(addToast({ message: handleErrorMessage(error), type: TOAST_TYPES.ERROR }));
	} finally {
		yield put(setLoading(false));
	}
}
function* fetchWebhooksEvents(): Generator {
	const state: any = yield select((state: RootState) => state.auth);
	try {
		const res: any = yield call(webhookService.getWebhookEvents, state.selectedTenant?.tenantId);
		yield put(setEvents(res?.data?.supportedEvents));
	} catch (error) {
		yield put(setError(true));
		yield put(addToast({ message: handleErrorMessage(error), type: TOAST_TYPES.ERROR }));
	}
}
function* registerWebhook(action:{type:string,payload:{  webhookUrl: string; events: string[]; description: string,callback?:()=>void }}): Generator {
  const { webhookUrl, events, description } = action.payload;
  yield put(setRegisterLoading(true))
	const state: any = yield select((state: RootState) => state.auth);
    const webhookState: any = yield select((state: RootState) => state.webhook);

	try {
		const res: any = yield call(webhookService.registerWebhook, {tenantId:state.selectedTenant?.tenantId,webhookUrl,events,description});
		yield put(setWebhooks([res?.data?.webhook,...webhookState.webhooks]))
		yield put(setWebhook(res?.data?.webhook))
		action.payload.callback?.();
	} catch (error) {
		yield put(setError(true));
		yield put(addToast({ message: handleErrorMessage(error), type: TOAST_TYPES.ERROR }));
	}finally{
      yield put(setRegisterLoading(false))

  }
}
function* deleteWebhook(action: { type: string; payload:{ webhookId: string,callBack?: () => void } }): Generator {
	yield put(setRegisterLoading(true));
	yield put(setError(false));
	yield put(setWebhook(null))
	const state: any = yield select((state: RootState) => state.auth);
	const webhookState: any = yield select((state: RootState) => state.webhook);
	try {
		yield call(webhookService.deleteWebhook, { tenantId: state.selectedTenant?.tenantId||"", webhookId: action.payload.webhookId||"" });
		const mod = webhookState.webhooks.filter((webhook: any) => webhook.webhookId !== action.payload.webhookId);
		yield put(setWebhooks(mod));
		action.payload.callBack?.();
		yield put(addToast({ message: "Webhook deleted successfully", type: TOAST_TYPES.SUCCESS }));
	} catch (error) {
		yield put(setError(true));
		yield put(addToast({ message: handleErrorMessage(error), type: TOAST_TYPES.ERROR }));
	} finally {
		yield put(setRegisterLoading(false));
	}
}

function* patchWebhook(action: { type: string; payload:{ webhookId: string,callBack?: () => void,data:Record<string,any> } }): Generator {
	yield put(setRegisterLoading(true));
	yield put(setError(false));
	yield put(setWebhook(null));
	const {webhookId,callBack,data} = action.payload
	const state: any = yield select((state: RootState) => state.auth);
	const webhookState: any = yield select((state: RootState) => state.webhook);
	try {
	yield call(webhookService.updateWebhook, { tenantId: state.selectedTenant?.tenantId||"", webhookId: webhookId||"",data });
		const mod = webhookState.webhooks.reduce((acc:Record<string,any>[],el:any)=>{
			if (el.webhookId===webhookId) {
				el = data
			}
			acc.push(el);
			return acc;
		},[])
		yield put(setWebhooks(mod));
		callBack?.();
	} catch (error) {
		yield put(setError(true));
		yield put(addToast({ message: handleErrorMessage(error), type: TOAST_TYPES.ERROR }));
	} finally {
		yield put(setRegisterLoading(false));
	}
}

function* webhookSaga() {
	yield takeLatest(HANDLE_GET_WEBHOOK_LIST, fetchWebhooksData), yield takeLatest(HANDLE_GET_WEBHOOK_EVENTS, fetchWebhooksEvents), yield takeLatest(HANDLE_REGISTER_WEBHOOK, registerWebhook),yield takeLatest(HANDLE_DELETE_WEBHOOK, deleteWebhook), yield takeLatest(HANDLE_PATCH_WEBHOOK, patchWebhook);
}

export default webhookSaga;
